<template>
  <div>
    <div class="d-flex w-100">
      <span
        :class="[
          'w-100 bmd-form-group mb-2 d-block form-label-group translatable',
          focused ? 'focused' : '',
          required ? 'required' : '',
        ]"
      >
        <v-select
          :readonly="readonly"
          :id="'select_' + _id"
          :options="options"
          label="display_text"
          :class="['form-control', selected.value !== '' ? 'vs--selected' : '']"
          v-model="selected"
          @search="load"
          :placeholder="placeholder"
          @focus="focused = true"
          @blur="focused = false"
        ></v-select>
        <label
          :for="'select_' + _id"
          class="form-label-group-label shorter"
          :class="placeholder.indexOf('<br>') > -1 ? 'two-line' : ''"
          v-html="placeholder"
        ></label>
      </span>
      <button @click="clear_value" class="btn btn-link px-2 clear-button">
        <i class="fa fa-times text-danger"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "v-select-enhanced",
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({ value: "", display_text: "" }),
    },
    indata: {
      type: Array,
      required: false,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    not_translated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      selected: { value: "" },
      focused: false,
    };
  },
  mounted() {
    this.load("");
  },
  methods: {
    load(q) {
      if (this.indata.length > 0) {
        this.options = this.indata;
        if (this.not_translated) {
          this.options.forEach((item) => {
            item.display_text = this.$t(item.display_text);
          });
        }
      } else {
        axios
          .get(
            window.base +
              "/library?type=" +
              this.type +
              "&query=" +
              q +
              "&qty=" +
              100 +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            this.options = response.data;
          });
      }
    },
    clear_value() {
      this.selected = { value: "" };
    },
  },
  computed: {
    _id() {
      return this._uid;
    },
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    type() {
      this.load("");
    },
    selected() {
      this.$emit("input", this.selected);
    },
  },
};
</script>
<style scoped>
.clear-button {
  margin-top: 0;
  /* border-bottom: 1px solid rgb(203, 203, 203) !important; */
  /* border-bottom-color: rgb(203, 203, 203) !important; */
  color: rgb(203, 203, 203) !important;
  border-radius: 0;
  padding: 0 !important;
  height: 54px;
  margin-left: -29px;
  padding: 10px !important;
  z-index: 123;
}
.clear-button i,
.clear-button svg {
  margin-top: 6px;
  color: #f44336 !important;
  fill: #f44336 !important;
}
</style>
